module.exports = __webpack_public_path__ + "img/rewardbackground.be5e5022.png";